<app-modal-base
  [title]="'API.generateNewApikey' | translate"
  [primaryButtonText]="'API.generate' | translate"
  [secondaryButtonText]="'Cancel' | translate"
  [primaryButtonId]="'finish-connection'"
  [secondaryButtonId]="'cancel-button'"
  (primaryClick)="generateApiKey()"
  (secondaryClick)="dialogRef.close(false)"
  (close)="dialogRef.close(false)"
  id="api-settings-modal"
>
  <div class="space-y-6">
    <app-alert-message
      class="rounded-lg"
      type="info"
      [message]="'API.clickHereToAccessTheApiDocumentation' | translate: { apiLink: getApiLink() }"
    ></app-alert-message>

    <div class="space-y-4" id="provider-selection">
      <app-custom-option-select [label]="'API.apiType'" [options]="options()" [currentValue]="'partner'">
      </app-custom-option-select>
    </div>

    <div class="space-y-4">
      <h3 class="text-lg font-semibold text-gray-900">
        {{ 'API.permissions' | translate }}
      </h3>

      <div class="space-y-1" id="permissions-api">
        @for (scope of scopes(); track scope) {
          <div class="flex items-center gap-4 p-2 rounded-lg hover:bg-gray-50 transition-colors">
            <label class="relative flex items-center">
              <input type="checkbox" class="peer sr-only" onclick="return false" disabled checked />
              <span
                class="flex items-center justify-center h-4 w-4 rounded border border-gray-300 bg-gray-400 cursor-not-allowed"
              >
                <i class="ph ph-check text-white text-xs peer-checked:block"></i>
              </span>
            </label>
            <div class="flex-1 min-w-0">
              <div class="flex items-center">
                <span class="font-semibold text-gray-900 text-base">{{ scope.name | translate }}</span>
                <button
                  class="ml-auto text-gray-500 hover:text-gray-700 transition-colors"
                  (click)="redirectToApiDocs(scope.link)"
                  aria-label="View API documentation"
                >
                  <i class="ph ph-arrow-line-up-right text-lg"></i>
                </button>
              </div>
              <p class="text-sm text-gray-400">
                {{ scope.description | translate }}
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</app-modal-base>
